
import { Component, Vue } from 'vue-property-decorator';
import { permissionsForm } from '@/config/forms/permissions';

@Component({})
export default class Permissions extends Vue {
  path = 'permissions';
  headers = [{
    text: 'Nombre',
    value: 'name',
  }, {
    text: 'Descripción',
    value: 'description',
  }, {
    text: 'Actions',
    value: 'actions',
    sortable: false,
  }];
  form = permissionsForm;
}
